import React from "react";
import { clsx } from "clsx";
import { SponsoredByAd } from "@bloomberg/media-ui-ads";
import typographyStyles from "@bloomberg/media-ui-tokens/css/typography.module.css";

import Title from "~components/shared/title/Title";
import { VariantBase } from "~components/shared/variant-base/VariantBase";
import { type VariationComponent, ZoneColumnCombo } from "~types/types";
import { integrityError } from "~utils/moduleIntegrity";

import integrityCheck from "./SectionFrontHeaderBrand.integrity";
import styles from "./SectionFrontHeaderBrand.module.css";

const SUPPORTED_REGIONS: ZoneColumnCombo[] = [
    ZoneColumnCombo.fullWidthContentWell,
];

export default function SectionFrontHeaderBrand(props: VariationComponent) {
    const integrity = integrityCheck(props);

    if (integrity.length) {
        return integrityError(integrity);
    }

    const { sponsored, subtitle, theme, title, items } = props;

    return (
        <VariantBase
            source={props}
            className={clsx(
                styles.SectionFrontHeaderBrand,
                theme ? styles[theme] : null
            )}
            gridClassName={clsx(
                styles.grid,
                items && Boolean(items.length) ? styles.hasLinks : null
            )}
            supportedRegions={SUPPORTED_REGIONS}
        >
            <div className={styles.titleContainer}>
                <Title
                    className={clsx(
                        styles.title,
                        typographyStyles.coreHeadlineXl
                    )}
                    title={title}
                />

                {sponsored && <SponsoredByAd className={styles.sponsoredBy} />}
            </div>

            {subtitle && <div className={styles.subtitle}>{subtitle}</div>}

            {items && Boolean(items.length) && (
                <ul className={styles.links}>
                    {items.map(({ headline, id, url }) => (
                        <li className={styles.link} key={`link-${id}`}>
                            <a href={url}>{headline}</a>
                        </li>
                    ))}
                </ul>
            )}
        </VariantBase>
    );
}
